import { Home, History, Help } from "@mui/icons-material";

export const navigations = [
  {
    href: "/",
    name: "Home",
    icon: <Home />,
  },
  {
    href: "/pastbids",
    name: "Past Bids",
    icon: <History />,
  },
  {
    href: "/faqs",
    name: "FAQs",
    icon: <Help />,
  },
];
